import { render, staticRenderFns } from "./PaymentRequestForm.vue?vue&type=template&id=9fa6c506"
import script from "./PaymentRequestForm.vue?vue&type=script&lang=js"
export * from "./PaymentRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports